export enum ScriptID {
  VibeGallery = 'vibeGallery',
  Trustpilot = 'trustpilot',
}
